import styled from 'styled-components';

const Container = styled.div`
  max-width: 380px;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: visible;
  border-radius: 4px;
  box-shadow: 0 10px 30px 1px rgba(137, 137, 137, 0.25);
  background-color: ${(props) => props.theme.colors['white']};

  @media (max-width: 845px) {
    max-width: 100%;
    box-shadow: none;
    border-radius: 0;
  }

  a {
    color: white;
    text-decoration: none;
  }

  h1 {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 22px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.09;
    letter-spacing: normal;
    color: #212529;
  }
  h2 {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 12px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors['dark']};
    text-transform: uppercase;
  }
  .communication {
    display: grid;
    grid-template-columns: 110px calc(100% - 110px);
    align-items: center;
  }
  .competitors {
    cursor: pointer;
  }

  .competitors > * {
    height: 66%;
  }

  .competitors:hover > .list > .tooltip {
    display: block;
  }
  .list {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  .rightContent {
    margin-left: auto;
  }

  .rowTitle {
    opacity: 0.9;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    font-weight: 400;
    line-height: 2;
    color: #2b3d54;
    margin: 0 10px;
    text-transform: capitalize;
    white-space: nowrap;
  }

  .tooltip {
    display: none;
    position: absolute;
    max-width: 400px;
    background-color: white;
    left: 390px;
    bottom: 100px;
    padding: 15px;
    border: rgba(39, 53, 68, 0.15) solid 1px;
    box-shadow: 0 10px 30px 1px rgba(137, 137, 137, 0.25);
    :after {
      content: '';
      width: 15px;
      height: 15px;
      position: absolute;
      background-color: white;
      border-left: rgba(39, 53, 68, 0.15) solid 1px;
      border-bottom: rgba(39, 53, 68, 0.15) solid 1px;
      left: -9px;
      top: 19px;
      transform: rotate(45deg);
    }
  }

  .tooltip > :not(:last-child):after {
    content: '';
    width: 90%;
    height: 1px;
    background-color: rgba(39, 53, 68, 0.15);
    margin: auto;
  }

  .rowLocation {
    white-space: nowrap;
  }

  .close {
    width: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 16px;
    border-radius: 50%;
    background-color: rgba(20, 29, 38, 0.12);
    color: rgba(39, 53, 68, 0.5);
    margin-right: 0;
    font-size: 12px;
  }
  .social {
    display: flex;
  }

  .social > * {
    margin-right: 5px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    background-color: rgba(173, 181, 189, 0.75);
    color: white;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    line-height: 10px;
  }

  .close > .icon {
    width: 12px;
    height: 12px;
    color: #2b3d54;
  }
  .removeContainer:hover {
    cursor: pointer;
  }
  .row {
    display: flex;
    flex-direction: column;
    color: ${(props) => props.theme.colors['dark-two']};
  }
  .row > * {
    margin-left: 13px;
  }
  .rowHeader {
    display: flex;
    align-items: center;
    span {
      color: #f5a623;
      font-size: 9px;
      margin-left: 5px;
    }
  }

  .rowBody {
    padding: 0 20px;
    margin: 0;
  }

  .rowLocation {
    color: rgba(39, 53, 68, 0.5);
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    font-size: 12px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  .rowTitle {
    opacity: 0.9;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors['dark']};
    margin-left: 10px;
  }
  .status {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .status > :last-child {
    margin-left: 10px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4b4b4b;
  }
  .phone {
    font-size: 20px;
  }
`;

const Back = styled.div<{
  hasPicture: boolean;
}>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  z-index: 2;
  visibility: visible;
  left: -16px;
  top: 240px;
  background-color: #1f2b37;
  position: absolute;
  color: white;
  display: flex;
  align-items: center;
  text-align: center;

  .icon {
    margin: auto;
  }

  :hover {
    cursor: pointer;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    left: 4px;
    top: ${(props) => (props.hasPicture ? '270px' : '10vh')};
    transform: scale(0.8);
  }
`;

const Row = styled.div`
  display: flex;
  min-height: 70px;
  flex-direction: row;
  border-top: rgba(39, 53, 68, 0.15) solid 1px;
  align-items: center;
  padding: 10px 10px 10px 35px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    padding: 10px 10px 10px 54px;
  }

  .dpVintagesList {
    max-height: 80px;
    overflow-y: auto;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      max-height: 60px;
    }
  }

  span {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.57;
    letter-spacing: normal;
    color: #4a4a4a;
    text-transform: uppercase;
  }

  p {
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px !important;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.57;
    letter-spacing: normal;
    color: #4a4a4a;
  }
`;

const Header = styled.div`
  padding: 25px 20px 20px 45px;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    padding: 16px 16px 16px 54px;
  }

  .website {
    color: black;
    font-size: 12px;
    margin-left: -10px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
  }

  h1 {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 22px;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4b4b4b !important;
  }

  .stars {
    color: #f5a623;
    display: flex;
    align-items: center;
    letter-spacing: 3px;
    margin-left: 5px;
  }
`;

const Picture = styled.div<{
  picture: string;
}>`
  height: 200px;
  overflow: hidden;
  background: url(${(props) => props.picture}) no-repeat center;
  -webkit-background-size: cover;
  background-size: cover;
  width: 100%;
  max-height: 200px;

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    border-radius: 4px;
    margin: 0 10px;
    width: auto;
  }
`;

const CompetitorTooltip = styled.div`
  padding: 10px;
  min-width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    line-height: 2;
  }
`;

export default Container;
export { Back, Row, Header, Picture, CompetitorTooltip };
